const cardHeaderStyles = (theme) => ({
  MuiCardHeader: {
    styleOverrides: {
      title: {
        fontWeight: "bold",
        fontSize: "1.75rem", // Base size
        wordBreak: "break-word", // Prevent overflow on small screens
        [theme.breakpoints.up("sm")]: {
          fontSize: "2.25rem",
        },
        [theme.breakpoints.up("md")]: {
          fontSize: "3rem",
        },
      },
      subheader: {
        fontSize: "1.25rem", // Base size
        [theme.breakpoints.up("sm")]: {
          fontSize: "1.5rem",
        },
        [theme.breakpoints.up("md")]: {
          fontSize: "2rem",
        },
      },
      avatar: {
        "& > .MuiAvatar-root": {
          width: 48, // Base size
          height: 48, // Base size
          fontSize: "1.5rem", // Base size
          fontWeight: "bold",
          [theme.breakpoints.up("sm")]: {
            width: 64,
            height: 64,
            fontSize: "2rem",
          },
          [theme.breakpoints.up("md")]: {
            width: 96,
            height: 96,
            fontSize: "2.5rem",
          },
        },
      },
      content: {
        padding: theme.spacing(0.5, 1), // Base padding
        [theme.breakpoints.up("sm")]: {
          padding: theme.spacing(1, 2),
        },
        [theme.breakpoints.up("md")]: {
          padding: theme.spacing(2, 3),
        },
      },
    },
  },
});

export default cardHeaderStyles;
